import { render, staticRenderFns } from "./big-article-card.vue?vue&type=template&id=15d51322&scoped=true&lang=pug&"
import script from "./big-article-card.vue?vue&type=script&lang=coffee&"
export * from "./big-article-card.vue?vue&type=script&lang=coffee&"
import style0 from "./big-article-card.vue?vue&type=style&index=0&id=15d51322&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d51322",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CraftVisual: require('/opt/build/repo/node_modules/@bkwld/cloak/components/craft-visual.coffee').default,Wysiwyg: require('/opt/build/repo/node_modules/@bkwld/cloak/components/wysiwyg.coffee').default,SmartLink: require('/opt/build/repo/nuxt-app/components/globals/smart-link.coffee').default})
